
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 10","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.219 4.648L6.72.146a.498.498 0 01.705 0l1.5 1.5c.095.096.145.221.145.356 0 .135-.055.26-.145.355L6.28 5.003 8.926 7.65a.5.5 0 01-.005.71L7.416 9.855a.51.51 0 01-.35.145.521.521 0 01-.355-.145L2.214 5.358a.498.498 0 010-.705l.005-.005z"}})])
          )
        }
      }
    